import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import PictureComp from '@/components/picture/PictureComp.vue';

import type { AuthorPageArticle } from '@/pages/editorial/AuthorPage.vue';
import { ArticleType } from '@/@types/graphql-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleCard',
  props: {
    article: null,
    lazy: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { article: AuthorPageArticle[number]; lazy: boolean }



// the content is an HTML string so this slices out the <h1> tags
const heading = computed(() =>
	props.article.title ? props.article.title.substring(4, props.article.title.length - 5) : ''
);

const content = computed(() => {
	switch (props.article.articleType) {
		case ArticleType.NewsArticle:
			return props.article.paragraph1;
		case ArticleType.TitleDetailArticle:
			return props.article.synopsis;
		case ArticleType.ReviewArticle:
			return props.article.snippet;
	}
});

return { __sfc: true,props, heading, content, PictureComp }
}

})